import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { useUseTemplateAvailableVersionQuery } from "./useTemplateAvailableVersion.generated.js";

export const useTemplateAvailableVersion = (templateId: string | null) => {
  const client = useApolloClient();
  const query = useUseTemplateAvailableVersionQuery({
    client,
    variables: {
      templateId: templateId ?? "",
    },
    skip: !templateId,
  });
  return !templateId
    ? null
    : getDataOrNull(query.data?.quoteTemplates)?.edges[0]?.node;
};
